module.exports = __webpack_public_path__ + "static/media/googleIcon.e9612850.png";